<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { CreatePortfolioEventPayload, PortfolioCreatorDialogViewModel } from "@Quest/Portfolios/Components/PortfolioCreatorDialog";
    import { WorkspaceReadModel } from "@Organizations/Workspaces/Domain/readmodels";


    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class PortfolioCreatorDialog extends Vue
    {
        get vm(): PortfolioCreatorDialogViewModel { return this.$props.viewModel as PortfolioCreatorDialogViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }
        get nameError(): string | null { return this.vm.errors?.find(error => error.Context === "Name")?.Error ?? null; }
        get workspaces(): WorkspaceReadModel[] { return this.vm.workspaces; }

        get workspaceId(): number { return this.vm.workspaceId; }
        set workspaceId(val: number) { this.vm.workspaceId = val; }

        get name(): string | null { return this.vm.name; }
        set name(val: string | null) { this.vm.name = val; }

        get description(): string | null { return this.vm.description; }
        set description(val: string | null) { this.vm.description = val; }

        handleFormSubmit()
        {
            this.vm.clearValidationErrors();
            this.$emit('create-portfolio', new CreatePortfolioEventPayload(this.workspaceId, this.name, this.description));
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create portfolio</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="portfolio-creator-dialog-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Workspace:</label>
                                <select v-model="workspaceId" class="form-control">
                                    <option v-for="w in workspaces" :value="w.WorkspaceId">{{w.Name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Portfolio name:</label>
                                <input type="text" v-model.trim="name" class="form-control" required maxlength="100" minlength="2">
                                <div class="error">{{nameError}}</div>
                            </div>
                            <div class="form-group">
                                <label>Description (optional):</label>
                                <textarea v-model.trim="description" class="form-control" />
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="portfolio-creator-dialog-form" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>